<template>
  <!-- 添加一个子账号页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
      <config-title-hang class="config_hight_change_account_number_manage">
        <!-- <span slot="config_title_hang_ele4">右击可删除一个子账号</span> -->
        <!-- <img slot="config_title_hang_ele3" src="~assets/img/config/tishilaba.png" alt /> -->
      </config-title-hang>

      <config-input-row>
        <img slot="config_hang_input_img" src="~assets/img/register/shouji_number.png" alt />
        <!-- 代号20200715-2 -->
        <input slot="config_hang_input_left" type="text" placeholder="英文字母开头（6-18位英文+数字组合）"
          v-model="oneServeSonAccountData.account" onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"
          :disabled="computedifdisabled" />
      </config-input-row>

      <config-input-row>
        <img slot="config_hang_input_img" src="~assets/img/register/shouji_mima.png" alt />
        <input slot="config_hang_input_left" type="password" placeholder="请输入子账号密码" autocomplete="new-password"
          onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="userPassWord" />
      </config-input-row>

      <config-input-row>
        <img slot="config_hang_input_img" src="~assets/img/register/shouji_queren.png" alt />

        <input slot="config_hang_input_left" type="password" placeholder="请再次输入子账号密码" autocomplete="new-password"
          onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="CuserPassWord" />
      </config-input-row>

      <config-title-hang>
        <span slot="config_title_hang_ele2">选择区域控制权限</span>
      </config-title-hang>

      <config-hang :selectState="selectRegionState" @click.native="regionSelectBtnHandle(0)">
        <span slot="config_hang_ele2">全部区域控制权限</span>
        <img slot="config_hang_weixuan" src="~assets/img/config/weixuan.png" alt />
        <img slot="config_hang_xuanzhong" src="~assets/img/config/xuanzhong.png" alt />
      </config-hang>

      <config-hang :selectState="!selectRegionState" @click.native="regionSelectBtnHandle(1)">
        <span slot="config_hang_ele2">部分区域控制权限</span>
        <img slot="config_hang_weixuan" src="~assets/img/config/weixuan.png" alt />
        <img slot="config_hang_xuanzhong" src="~assets/img/config/xuanzhong.png" alt />
      </config-hang>

      <config-title-hang class="config_hight_jianxi" v-if="selectRegionState === false"></config-title-hang>

      <config-hang v-if="selectRegionState === false" @click.native="selectRegionBtnHandle">
        <span slot="config_hang_ele2">控制区域选择</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>

      <config-title-hang class="config_hight_jianxi" v-if="selectRegionState === false"></config-title-hang>
      <div v-if="oneServeSonAccountData.accountId === ''" class="xiaotishi_style">小提示：确定申请并返回：当您点击此按钮时，意味着您在申请普通子账号。
      </div>
      <div v-else class="xiaotishi_style">
        小提示：确定修改并返回：当您点击此按钮时，意味着您在修改更新普通子账号，这时建议你重新输入新的密码，确保密码的可用性。成功之后，之前生成的二维码也会同时失效。</div>

      <div v-if="oneServeSonAccountData.accountId === ''" class="xiaotishi_style">小提示：生成小程序快捷登录二维码：当您点击此按钮时，不需要输入密码。
      </div>
      <div v-else class="xiaotishi_style">小提示：更新小程序快捷登录二维码：当您点击此按钮时，不需要输入密码，成功之后，之前生成的二维码也会同时失效。</div>
      <div v-if="oneServeSonAccountData.accountId === ''" class="public_config_que_ren_btn" @click="configQueRenBtn(1)">
        确定申请并返回</div>
      <div v-else class="public_config_que_ren_btn" @click="configChangeQueRenBtn(1)">确定修改并返回</div>
      <div v-if="oneServeSonAccountData.accountId === ''" class="public_config_que_ren_btn" @click="xiaoChengXuCode">
        生成小程序快捷登录二维码</div>
      <div v-else class="public_config_que_ren_btn" @click="updataxiaoChengXuCode">更新小程序快捷登录二维码</div>
    </div>
  </div>
</template>

<script>
import ConfigInputRow from '@/components/common/config/config-input-row';
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";

//公用函数
import {
  countSHandle,
  checkCellPhoneNumber,
  checkPassword,
  checkPasswordC,
  checkCityCode,
  checkImgCode,
  checkUserData,
  checkCallphoneCrc,
  checkSonAccountNumber
} from "common/beforeLogin/RegisterPage";

export default {
  data() {
    return {
      oneServeSonAccountData: {
        account: "",
        accountId: "",
        controlType: 0,
        regionList: [],
        userId: ""
      },
      selectRegionState: true,
      userPassWord: "",
      CuserPassWord: ""
    };
  },
  components: {
    ConfigInputRow,
    configHang,
    configTitleHang
  },
  methods: {
    regionSelectBtnHandle(data) {
      this.oneServeSonAccountData.controlType = data;
      console.log(
        typeof this.oneServeSonAccountData.controlType +
        this.oneServeSonAccountData.controlType
      );
      //////改变勾选状态
      if (this.oneServeSonAccountData.controlType === 0) {
        this.selectRegionState = true;
      } else {
        this.selectRegionState = false;
      }
      console.log(this.$store.state.configinfo.oneServeSonAccountData);
    },
    configQueRenBtn(type) {
      //保存并返回按钮
      /// 添加子账号并完成设置权限接口

      if (!checkSonAccountNumber(this.oneServeSonAccountData.account)) return; ///检查账号
      if (!checkPassword(this.userPassWord)) return; ///检查密码
      if (!checkPasswordC(this.userPassWord, this.CuserPassWord)) return; ///检查两次密码一致
      ////处理一下区域ID的入参
      let regionList = [];
      let listLength = this.$store.state.configinfo.selectRegionList.length;
      for (let i = 0; i < listLength; i++) {
        regionList[i] = this.$store.state.configinfo.selectRegionList[
          i
        ].regionId;
      }
      console.log(regionList);

      ///检查区域 id列表是否为空20200418补BUG
      if (!this.selectRegionState) {
        ///说明现在是部分区域的选择状态
        if (regionList.length === 0) {
          this.$toast("请至少选择一个区域的控制权限！");
          return;
        }
      }

      this.$request({
        method: "post",
        url: "/user/saveSubAccount",
        data: {
          token: this.$store.state.token,
          regionIds: regionList,
          account: this.oneServeSonAccountData.account,
          password: this.userPassWord,
          controlType: this.oneServeSonAccountData.controlType
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.ServeSonAccountData = res.data.data; ////拿到服务器返回的数据结果
            // this.$store.dispatch("asyUpdataServeSceneData", this.ServeSceneData); ///异步提交信息到仓库
            if (type == 1) {
              this.$showTipsToast(1, "申请成功", true); ////提示框
              this.$router.go(-1);
            } else if (type == 2) {
              ///小程序二维码调用的接口
              this.GenerateCode(
                this.oneServeSonAccountData.account,
                this.userPassWord
              ); ///根据账号密码生成二维码
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    configChangeQueRenBtn(type) {
      //保存修改子账号并返回按钮
      /// 修改子账号信息(密码/权限)接口

      if (!checkSonAccountNumber(this.oneServeSonAccountData.account)) return; ///检查账号
      if (!checkPassword(this.userPassWord)) return; ///检查密码
      if (!checkPasswordC(this.userPassWord, this.CuserPassWord)) return; ///检查两次密码一致
      ////处理一下区域ID的入参
      let regionList = [];
      let listLength = this.$store.state.configinfo.selectRegionList.length;
      for (let i = 0; i < listLength; i++) {
        regionList[i] = this.$store.state.configinfo.selectRegionList[
          i
        ].regionId;
      }

      ///检查区域 id列表是否为空20200418补BUG
      if (!this.selectRegionState) {
        ///说明现在是部分区域的选择状态
        if (regionList.length === 0) {
          this.$toast("请至少选择一个区域的控制权限！");
          return;
        }
      }
      ////// 处理一下密码没有修改的情况  密码没有修改时，密码传空 补BUG换了一个中间变量的写法
      console.log(this.userPassWord);
      let TempUserPassWord = ""; //密码置空后  传给服务端
      if (this.userPassWord != "********") {
        ////说明用户修改了密码
        TempUserPassWord = this.userPassWord;
      }

      this.$request({
        method: "post",
        url: "/user/updateSubAcountInfo",
        data: {
          token: this.$store.state.token,
          regionIds: regionList,
          account: this.oneServeSonAccountData.account,
          password: TempUserPassWord,
          controlType: this.oneServeSonAccountData.controlType
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.ServeSonAccountData = res.data.data; ////拿到服务器返回的数据结果
            // this.$store.dispatch("asyUpdataServeSceneData", this.ServeSceneData); ///异步提交信息到仓库
            if (type == 1) {
              this.$showTipsToast(1, "修改成功", true); ////提示框
              this.$router.go(-1);
            } else if (type == 2) {
              ///小程序二维码调用的接口
              this.GenerateCode(
                this.oneServeSonAccountData.account,
                this.userPassWord
              ); ///根据账号密码生成新的二维码
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectRegionBtnHandle() {
      ///控制区域选择按钮 按下了

      this.$store.dispatch("asyUpdatauserPassWord", this.userPassWord); ///提交用户密码
      this.$store.dispatch("asyUpdataCuserPassWord", this.CuserPassWord); ///提交用户的再次输入密码
      this.$router.push("SonAccountSelectRegion");
    },
    autoSonAccountPassword() {
      //根据账号生成随机密码 并获取账号的token，用来后续生成小程序二维码
      if (!checkSonAccountNumber(this.oneServeSonAccountData.account)) return; ///检查账号
      let passwordLenght = 8;
      //获取随机8位密码
      let number = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
      let letter = ["a", "b", "c", "d", "e", "f", "g", "h", "j", "k"];
      let password = "";
      let letterSum = "";
      let numberSum = "";
      for (let k = 0; k < 3; k++) {
        for (let i = 0; i < 1; i++) {
          let count = parseInt(Math.random() * 10);
          letterSum += letter[count];
          numberSum += number[count];
          password = letterSum + numberSum;
        }
      }
      console.log("得到随机密码" + password);
      this.userPassWord = password;
      this.CuserPassWord = password;
    },
    xiaoChengXuCode() {
      this.autoSonAccountPassword(); ///获取8位随机密码
      // return;
      this.configQueRenBtn(2); ///注册账号
    },
    GenerateCode(account, passwoed) {
      console.log("获取小程序快捷登录二维码");
      ///获取小程序快捷登录二维码
      this.$request({
        method: "post",
        url: "/wechat/findUnlimited",
        data: {
          token: this.$store.state.token,
          //这里是你自己要传给小程序的参数，自己需要
          scene: account + "+" + passwoed, ///小程序传参  传递账号密码
          page: "pages/beforeLogin/LoginPage", //不传就是打开首页
          width: 210
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            console.log(res.data);
            let xiaoChengXuCodeErWeiMa = this.computedBase64(
              res.data.data.base64Img
            );
            let objData = {
              xiaoChengXuCodeErWeiMa: xiaoChengXuCodeErWeiMa,
              account: account,
              userPassWord: passwoed, //20200722-1
              appUrl: res.data.data.appUrl //20250510-1
            };
            console.log(objData);
            // this.$closeTipsToast()//先关闭一下
            // console.log('121111111111111111111111111111111111111')
            this.$showTipsToast(20, objData, false, 1000, 0, true, false);
            this.$router.go(-1);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    updataxiaoChengXuCode() {
      ///更新小程序二维码  老的二维码讲失效
      this.autoSonAccountPassword(); ///获取8位随机密码
      // return;
      this.configChangeQueRenBtn(2); ///修改账号密码
    },
    computedBase64(xiaoChengXuCodeErWeiMa) {
      ///图片验证码的BASE64数据
      return "data:image/jpeg;base64," + xiaoChengXuCodeErWeiMa;
    }
  },
  computed: {
    computedifdisabled() {
      /////判断子账号的输入框是启用还是禁用
      if (this.oneServeSonAccountData.accountId === "") {
        return false; ////子账号的输入框启用
      } else {
        return true; ////子账号的输入框禁用
      }
    }
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    this.oneServeSonAccountData = this.$store.state.configinfo.oneServeSonAccountData;
    console.log(this.$store.state.configinfo.oneServeSonAccountData);
    this.regionSelectBtnHandle(this.oneServeSonAccountData.controlType); ////更新勾选状态
    this.userPassWord = this.$store.state.configinfo.userPassWord; ////拿到仓库密码
    this.CuserPassWord = this.$store.state.configinfo.CuserPassWord; ///拿到仓库的二次输入密码

    console.log(this.userPassWord);
  }
};
</script>

<style>
.config_hight_change_account_number_manage {
  height: 40px;
  line-height: 40px;
}

.config_hight_change_account_number_manage img {
  right: 195px;
}

.config_hight_jianxi {
  height: 20px;
}

.erweima {
  width: 500px;
  height: 400px;
}
</style>
